import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CarouselEditCard, CarouselEditCardProps } from './index'

export interface SortableCarouselEditCardProps extends CarouselEditCardProps {
  id: string
}

export function SortableCarouselEditCard({
  id,
  isLoading,
  ...props
}: SortableCarouselEditCardProps) {
  const {
    isSorting,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div ref={setNodeRef} style={style}>
      <CarouselEditCard
        {...props}
        id={id}
        isLoading={isLoading || isDragging || isSorting}
        dragHandleProps={{
          ...attributes,
          ...listeners,
        }}
      />
    </div>
  )
}
